import React from "react";
import "./DevMile.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class DevMile extends React.Component {
    render() {
        return(
            <div>
                <Nav/>
                <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Investment Environment</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">Transportation and Logistics</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/InvestRegis"> 02 Investment Registration</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab">03 Industries & Parks</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoBusiness">Eco-Business Park</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoInov">Eco-Innovation</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Overall">Overall Introduction</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab">04 Real Estate Development</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan">Development Plan</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevMile">Development Milestone</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">05 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Development Milestones/Forcast</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>How to set up office/company in the Good Morning Bamboo Eco-City?</p>
        <p className="text-justify">The Good Morning Bamboo Eco-City (the Eco-City) has made early progress four (4) months since the development of its disruptive innovative product and construction technologies in 2019. There will be a vibrant community in the Start-Up Area of the Eco-City, with over 2,000 people living and working here by the end of 2021. Over 2,500 green homes will be completed and there are two schools in the Start-Up Area with more than some 1,000 students. Within the neighbourhoods will be two business parks in the Start-Up Area, offering excellent job opportunities. A wide-range of amenities, including banks, convenience stalls, restaurants, a market, a clinic, and recreational facilities will also be located at the Commercial Street and a Community Centre. Residents can also visit many public parks for recreational activities. By the end of 2021, three tourism Hotels will start operation within the Eco-City. An international Hospital with about 100 beds will also start operation in 2022. A mall will also commence its construction and will be in use in two years’ from 2021. 
<br/><br/>Top international in collaborations with local developers will partner Good Morning Bamboo Agro-Forestry and Investment Service to develop green homes in the Eco-City.

</p>
   
       </div>
      
     </div>
   </div>
            </div>
        )
    }
}
export default withRouter(DevMile);